// src/lib/tiendaApi.js
// Llamadas al backend real de la tienda (carpeta /api del servidor).
// En local, setupProxy.js reenvía estas rutas al servidor de producción para
// poder probarlas sin desplegar el sitio.

const request = async (url, options) => {
  const res = await fetch(url, {
    credentials: "same-origin",
    ...options,
  });

  const data = await res.json().catch(() => null);

  if (!res.ok || data?.error) {
    throw new Error(data?.error || `Error ${res.status}`);
  }

  return data;
};

const postJson = (url, body) =>
  request(url, {
    method: "POST",
    headers: { "Content-Type": "application/json" },
    body: JSON.stringify(body),
  });

// --- Cuenta de cliente ---

export const registrarCliente = (datos) => postJson("/api/cliente_registro.php", datos);

export const loginCliente = (email, password) =>
  postJson("/api/cliente_login.php", { email, password });

export const logoutCliente = () => postJson("/api/cliente_logout.php", {});

export const sesionCliente = () => request("/api/cliente_sesion.php");

export const misPedidos = () => request("/api/cliente_mis_pedidos.php");

export const listarChatCliente = () => request("/api/cliente_chat_listar.php");

export const enviarMensajeChat = (mensaje) =>
  postJson("/api/cliente_chat_enviar.php", { mensaje });

export const crearReserva = (datos) => postJson("/api/crear_reserva.php", datos);

export const listarCarrito = () => request("/api/cliente_carrito_listar.php");

export const agregarAlCarrito = (datos) => postJson("/api/cliente_carrito_agregar.php", datos);

export const eliminarDelCarrito = (id) =>
  postJson("/api/cliente_carrito_eliminar.php", { id });

export const confirmarCarrito = () => postJson("/api/cliente_carrito_confirmar.php", {});

export const solicitarResetPassword = (email) =>
  postJson("/api/cliente_solicitar_reset.php", { email });

export const restablecerPassword = (email, codigo, password) =>
  postJson("/api/cliente_restablecer_password.php", { email, codigo, password });

// --- Panel de administración ---

export const solicitarCodigoAdmin = (email) =>
  postJson("/api/admin_solicitar_codigo.php", { email });

export const verificarCodigoAdmin = (email, codigo) =>
  postJson("/api/admin_verificar_codigo.php", { email, codigo });

export const listarReservas = () => request("/api/admin_listar_reservas.php");

export const actualizarEstadoReserva = (codigo, estado) =>
  postJson("/api/admin_actualizar_estado.php", { codigo, estado });

export const actualizarPagoReserva = (codigo, pagado) =>
  postJson("/api/admin_actualizar_pago.php", { codigo, pagado });

export const cerrarSesionAdmin = () => postJson("/api/admin_cerrar_sesion.php", {});

export const listarClientesChatAdmin = () => request("/api/admin_chat_listar_clientes.php");

export const listarChatAdmin = (clienteId) =>
  request(`/api/admin_chat_listar.php?cliente_id=${clienteId}`);

export const responderChatAdmin = (clienteId, mensaje) =>
  postJson("/api/admin_chat_responder.php", { cliente_id: clienteId, mensaje });
